import App from './Player/App.svelte';

const app = new App({
    target: document.body,
});

export default app;
